import { createContext, useState } from 'react'

export const OrderContext = createContext({
    orders: [],
    addOrderToCart: () => { },
    formatOrder: () => { },
});

export function OrderProvider({ children }) {
    const [orderInfo, setOrderInfo] = useState([])
    function addOrderToCart(order_data) {
        setOrderInfo(
            [
                ...orderInfo,
                {
                    order_data
                }
            ]
        )
        // setOrderInfo(props)
    }


    function formatOrder() {
        setOrderInfo([])
    }



    const orderContextValue = {
        orders: orderInfo,
        addOrderToCart,
        formatOrder,
    }

    return (
        <OrderContext.Provider value={orderContextValue}>
            {children}
        </OrderContext.Provider>
    )
}


export default OrderProvider;